import { createColumnHelper } from "@tanstack/react-table";
import { formatDateTime, formatPrice } from "../../../../utils/format";
import { useNavigate } from "react-router-dom";
import Table from "../../../../components/ui/Table/Table";
import { indexer } from "../../../../utils/utils";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total, handleClickDetailProd) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);
        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "적립/사용 일시",
      cell: (info) => {
        const val = info.getValue();

        return (
          <span className="w-36 text-center">
            {val ? formatDateTime(val) : "-"}
          </span>
        );
      },
    }),

    columnHelper.accessor((row) => row?.productOrderParent, {
      header: "관련 주문 상품명",
      cell: (info) => {
        const val = info.getValue()?.productOrder[0]?.product?.name;
        const id = info.getValue()?.productOrder[0]?.product?.productGroupId;

        const prodName =
          val?.length > 10 ? (
            <div>
              {val?.substring(0, 25)}
              <br />
              {val?.slice(25)}
            </div>
          ) : (
            val
          );
        return (
          <div
            className="cursor-pointer underline"
            onClick={() => handleClickDetailProd(id)}
          >
            {val ? prodName : ""}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.description, {
      header: "내용",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.trxType, {
      header: "적립 / 사용",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? (val === "INCOMING" ? "적립" : "사용") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "적립 포인트",
      cell: (info) => {
        const val = info.getValue()?.pointAmount;
        const type = info.getValue()?.trxType;
        return (
          <div>{val && type === "INCOMING" ? `+${formatPrice(val)}` : ""}</div>
        );
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "사용 포인트",
      cell: (info) => {
        const val = info.getValue()?.pointAmount;
        const type = info.getValue()?.trxType;

        return <div>{val && type === "OUTGOING" ? `-${val}` : ""}</div>;
      },
    }),

    // columnHelper.accessor((row) => row?.points, {
    //   header: "보유 포인트",
    //   cell: (info) => {
    //     const val = info.getValue();
    //     return <div>{val ? val : "-"}</div>;
    //   },
    // }),
  ];
};

export function HospitalPointTable(props) {
  const { getDataTableProps, isEmpty } = props;
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll || getDataTableProps().total;
  const navigate = useNavigate();
  const handleClickDetailProd = (id) => {
    navigate(`/product-management/product-group/${id}`);
  };

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center text-[14px]">
          포인트 적립/사용 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasSave={false}
          hasPageSizeFilter={false}
          hasSort={false}
          columns={columns(
            currentPage,
            pageSize,
            totalData,
            handleClickDetailProd,
          )}
          boldColumns={["사용 포인트"]}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
